import { NgModule } from '@angular/core'
import { MatIconModule } from '@angular/material/icon';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatListModule } from '@angular/material/list'

@NgModule({
    imports: [],
    exports: [
        MatIconModule,
        MatBottomSheetModule,
        MatListModule
    ],
    declarations: []
})
export class optionsMaterialModule { }
